import { ApolloClient, NormalizedCacheObject, useQuery } from '@apollo/client';

import CATEGORIES_QUERY from 'graphql/categories/queries/categories.graphql';

import type { GetCategoriesQuery } from 'graphql/types';

export const useCategories = () =>
  useQuery<GetCategoriesQuery>(CATEGORIES_QUERY);

export const getCategoriesSsr = async (
  client: ApolloClient<NormalizedCacheObject>
) => {
  try {
    return await client.query<GetCategoriesQuery>({
      query: CATEGORIES_QUERY,
    });
  } catch (err) {
    return err;
  }
};
